import Vue from 'vue';

import VueRouter from 'vue-router';
Vue.use(VueRouter)

import $store from '../store/store'
import childrenRoutes from "../routes";

const routes = [
    {
        name: 'root',
        path: '/',
        components: {
            container: () => import('./../view/app/portal.vue'),
        },
        redirect: {
            name: 'home'
        },
        children: [
            {
                name: 'auth',
                path: 'auth/:t?',
                components: {
                    keepalive: () => import('./../view/auth/auth.vue'),
                }
            },
            {
                name: 'produtos',
                path: 'produto/:t?',
                components: {
                    keepalive: () => import('./../view/produto/produto.vue'),
                },
                meta: {
                    title: 'Ficar protegido',
                    root: true,
                    auth: false,
                },
            },
            {
              name: 'home',
              path: 'home',
              component: () => import('../view/quote/home.vue'),
              meta: {
                title: 'Bem-vindo ao Cotador',
                root: true,
                auth: false,
              },
            },
            {
              name: 'quote-form',
              path: 'quote-form',
              component: () => import('../view/quote/quoteForm.vue'),
              meta: {
                title: 'Dados da Cotação',
                root: true,
                auth: false,
              },
            },
            {
              name: 'calculate-quote',
              path: 'calculate-quote',
              component: () => import('../view/quote/calculateQuote.vue'),
              meta: {
                title: 'Cálculo da Cotação',
                root: true,
                auth: false,
              },
            },
            {
              name: 'dashboard-quote',
              path: 'dashboard-quote',
              component: () => import('../view/quote/dashboardQuote.vue'),
              meta: {
                title: 'Dashboard de Acompanhamento',
                root: true,
                auth: false,
              },
            },
            {
                name: 'comprarProduto',
                path: 'comprar-produto/:id/:origin?/:personType?/:token?',
                component: () => import('./../view/produto/produtoComprar.vue'),
                props: (route) => ({
                    id: route.params.id,
                    origin: route.params.origin,
                    personType: route.params.personType
                }),
                meta: {
                    title: 'Comprar Produto',
                    auth: false,
                    bch: ['produtos']
                },
            },
            {
                name: 'quote',
                path: 'quote/:quoteId?',
                component: () => import('./../view/produto/quote.vue'),
                props: (route) => ({
                    quoteId: route.params.quoteId,
                }),
                meta: {
                    title: 'Quote',
                    auth: false,
                },
            },
        ],
    },
    {
        path: '*',
        redirect: {
            name: 'notfound'
        },
        meta: {
            auth: false,
        }
    }
]

routes[0].children = routes[0].children.concat(childrenRoutes)

const router = new VueRouter({
    mode: 'history',
    // eslint-disable-next-line no-undef
    base: process.env.BASE_URL,
    routes: routes
})

router.beforeEach((to, from, next) => {
    // console.log('router beforeEach');
    $store.commit('hidemsg');
    next();
})

export default router
